<style scoped>
    #foo {
        position: fixed;
        bottom: 0;
        right: 0;
        pointer-events: none;
    }


    .Round-Rectangle {
        margin: 5px;
        width: 100px;
        height: 28px;
        border: 1px solid #d9d9d9;
    }

    .table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
        padding: 5px;
        vertical-align: central;
        border-top: 1px solid #dddddd;
        font-size: 14px;
    }

    .table > thead > tr > th {
        font-size: 13px;
        font-weight: 600;
    }


    .col-header {
        font-size: 13px;
        font-weight: 600;
        padding: 1px !important;
        padding-top: 10px !important;
        line-height: 20px !important;
    }

    .drugColumn {
        min-width: 150px;
    }

    .form-control {
        padding-right: 7px;
        padding-left: 7px;
    }

    .no-border {
        border: 0px !important;
    }

    tr.border_top td {
        border-top: 2pt solid #808080 !important;
        padding-top: 5px !important;
    }

    .border_top_thin td {
        border-top: 0.5pt solid #d9d9d9 !important;
    }

    .roundTable td, th {
        line-height: 20px !important;
        margin: 2px;
        padding: 2px;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 13px
    }

    .dosagerow td {
        background: #f5f5f5
    }

    .row_headers th {
        font-size: 12px;
        font-weight: 600;
        padding: 0px;
        margin: 0px;
        line-height: 15px !important;
    }


    tr.saved_medication td {
        background-color: #e9fcf8 !important;
    }

    tr.unsaved_medication td {
        background-color: #f2f2f2 !important;
    }

    tr.modified_medication td {
        background-color: #d4e9f7 !important;
    }

    tr.new_medication td {
        background-color: #e9f4fb !important;
    }
</style>
<template>
    <div class="col-md-12">
        <div class="row">
            <ul class="nav nav-pills pull-right">
                <li class="dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                        <strong>{{currentCycleTitle}}</strong> ( {{FormatDate(cycleStartDate)}} - {{FormatDate(cycleEndDate)}} )<span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu">
                        <template v-for="(cycle, index) in cycles">
                            <template v-if="index==0">
                                <li>
                                    <a href="#" @click.prevent.self="setCycle(cycle)">
                                        <strong class="text-primary">Next</strong><br />
                                        {{FormatDate(cycle.startDate)}} - {{FormatDate(cycle.endDate)}}
                                    </a>
                                </li>
                                <li class="divider"></li>
                            </template>

                            <template v-if="index==1">
                                <li>
                                    <a href="#" @click.prevent.self="setCycle(cycle)">
                                        <strong class="text-danger"> Current</strong><br />
                                        {{FormatDate(cycle.startDate)}} - {{FormatDate(cycle.endDate)}}
                                    </a>
                                </li>
                                <li class="divider"></li>
                            </template>

                            <template v-if="index>1">
                                <li>
                                    <a href="#" @click.prevent.self="setCycle(cycle)">
                                        {{FormatDate(cycle.startDate)}} - {{FormatDate(cycle.endDate)}}
                                    </a>
                                </li>
                            </template>
                        </template>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="row" v-if="controller && controller.IsInitialized">
            <!--<LoaderControl :loading="isLoading">-->
            <!--<transition name="fade" :duration="1000">
                <div v-if="this.isLoading" style="width:100%; position:absolute; top:100px;text-align:center; vertical-align:central">

                    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                    <span class="sr-only">Loading...</span>

                </div>
            </transition>-->
            <div>
                <table class="table" style="min-height:100px">
                    <thead>
                    </thead>
                    <tbody>
                        <template v-for="item in controller.DispensationItems">
                            <template>
                                <tr :class="{'row_changed' : item.HasEndDateChanged}">
                                    <td colspan="100" style="padding-top:10px" class="no-border">
                                        &nbsp;
                                        {{item.DatesDiff}}
                                    </td>
                                </tr>
                                <!---->
                                <tr class="border_top"
                                    :class="{
                                    'saved_medication': !item.IsVirtual && !item.IsNew,
                                    'unsaved_medication': item.IsVirtual && !item.IsNew,
                                    'new_medication': item.IsNew}">
                                    <td colspan="100" style="margin-top:0px">
                                        <a class="btn btn-md btn-warning" v-if="item.HasChanged && !item.IsNew" @click.prevent="item.Reset()">Item Updated</a>
                                        <a class="btn btn-md btn-primary" v-if="item.HasChanged && !item.IsNew" @click.prevent="item.Reset(); item.IsUpdating=false">Reset Changes</a>
                                        <a class="btn btn-md btn-primary" v-if="item.IsUpdating && !item.HasChanged && !item.IsNew" @click.prevent="item.Reset(); item.IsUpdating=false">Close</a>

                                        <a class="btn btn-md btn-info" v-if="item.IsNew">New Item</a>
                                        <a class="btn btn-md btn-primary" v-if="item.IsNew" @click.prevent="controller.RemoveItem(item)">Remove \ Cancel</a>

                                        <a class="btn btn-danger btn-md pull-right" v-if="item.hasError">
                                            <i class="fa fa-exclamation-triangle"></i> Has Errors : {{item.message}}
                                        </a>
                                        <!--
    <span class="pull-right" v-if="item.IsNew">
        <a class="btn btn-info btn-xs" :class="{'btn-warning' : controller.hasError}">
            New Drug
        </a>

        <a class="btn btn-danger btn-xs" v-if="item.hasError">
            <i class="fa fa-exclamation-triangle"></i> Has Errors : {{item.message}}
        </a>
    </span>

    <span class="pull-right" v-if="item.HasChanged && !item.IsNew && item.IsVirtual">

        <a class="btn btn-warning btn-xs" v-if="item.HasVirtualItemStarted">
            Item Started ({{FormatDate(item.startDate.value)}} to {{FormatDate(item.endDate.value)}})
        </a>

        <a class="btn btn-danger btn-xs" v-if="item.HasVirtualItemRemoved" @click.prevent.self="item.Reset()">
            Item Marked to be Removed <i class="fa fa-times"></i>
        </a>

        <a class="btn btn-danger btn-xs" v-if="item.hasError">
            <i class="fa fa-exclamation-triangle"></i> Has Errors : {{item.message}}
        </a>

    </span>
    <span class="pull-right" v-if="item.HasChanged && !item.IsNew && !item.IsVirtual">

        <a class="btn btn-warning btn-xs" v-if="item.HasEndDateChanged" @click.prevent.self="item.Reset()">
            Item Stopped ({{FormatDate(item.endDate.value)}}) <i class="fa fa-times"></i>
        </a>

        <a class="btn btn-warning btn-xs" v-if="item.HasDetailsChanged" @click.prevent.self="item.Reset()" href="#">
            Item Updated <i class="fa fa-times"></i>
        </a>
        <a class="btn btn-warning btn-xs" v-if="item.HasDosageChanged" @click.prevent.self="item.Reset()">
            Dosage Changed ( New Item ) <i class="fa fa-times"></i>
        </a>

        <a class="btn btn-danger btn-xs" v-if="item.hasError">
            <i class="fa fa-exclamation-triangle"></i> Has Errors : {{item.message}}
        </a>

                                        </span>
                                        -->
                                    </td>
                                </tr>
                                <tr :class="{
                                    'text-warning':item.HasEndDateChanged,
                                    'text-info' : item.IsNew,
                                     'saved_medication': !item.IsVirtual && !item.IsNew,
                                    'unsaved_medication': item.IsVirtual && !item.IsNew,
                                    'new_medication': item.IsNew}">
                                    <td colspan="100" class="no-border" style="vertical-align:middle">
                                        <span v-if="!item.IsCycleActive" class=" text-danger">
                                            <i class="fa fa-exclamation-triangle fa-2x"></i>
                                            <span style="font-size:20px">
                                                [Inactive]
                                            </span>
                                            &nbsp;&nbsp;
                                        </span>
                                        <span :class="{'text-info' : item.IsNew, 'text-success':!item.IsVirtual && !item.IsNew, 'text-warning': item.IsVirtual}">
                                            <span>
                                                <TooltipControl v-if="item.IsVirtual" title="Unsaved Medication">
                                                    <i class="fa fa-circle-o fa-2x text-warning" />
                                                </TooltipControl>
                                                <TooltipControl v-if="!item.IsVirtual && !item.IsNew" title="Saved Medication">
                                                    <i class="fa fa-check-circle-o fa-2x text-success" />
                                                </TooltipControl>
                                                <TooltipControl v-if="item.IsNew" title="New Medication">
                                                    <i class="fa fa-circle-o fa-2x text-info" />
                                                </TooltipControl>
                                            </span>
                                            &nbsp;

                                            <!--<span style="font-size:18px">{{item.IsNew ? "[New]" : !item.IsVirtual ? "[Saved]" : "[UnSaved]"}}</span>-->
                                            <span style="font-size:20px">
                                                {{item.IsPharmacyDispensed ? "Pharmacy Dispensed" : "Carehome Added"}}
                                            </span>
                                        </span>

                                        <template>
                                            <!--Action Buttons-->
                                            <span v-if="!item.IsNew && !item.IsVirtual">
                                                <a class="btn btn-warning btn-xs"
                                                   v-if="!item.IsUpdating"
                                                   style="width:100px;margin:2px" @click.prevent="EditItem(item)"><i class="fa fa-pencil" />&nbsp;Edit Details</a>
                                                <a class="btn btn-danger btn-xs"
                                                   v-if="!item.IsUpdating"
                                                   style="width:125px;margin:2px" @click.prevent="StopItem(item)"><i class="fa fa-ban" />&nbsp;Stop Medication</a>
                                                <button class="btn btn-xs btn-primary" @click="item.showInEMAR.value = !item.showInEMAR.value">
                                                    <i class="fa fa-check"></i>
                                                    {{ (item.showInEMAR.value ? "Disable" : "Enable") + " EMAR"}}
                                                </button>
                                            </span>
                                            <span v-if="!item.IsNew && item.IsVirtual">
                                                <a class="btn btn-warning btn-xs"
                                                   style="width:125px;margin:2px" @click.prevent="EditItem(item)"><i class="fa fa-pencil" />&nbsp;Edit Details</a>

                                                <TooltipControl v-if="!item.IsUpdating && !item.HasVirtualItemStarted" title="Activate this medication">
                                                    <a class="btn btn-success btn-xs"
                                                       style="width:125px;margin:2px" @click.prevent="StartItem(item)"><i class="fa fa-plus" />&nbsp;Start Medication</a>
                                                </TooltipControl>
                                                <TooltipControl v-if="!item.IsUpdating && !item.HasVirtualItemRemoved " title="Remove medication from the list">
                                                    <a class="btn btn-danger btn-xs"
                                                       style="width:145px;margin:2px" @click.prevent="RemoveItem(item)"><i class="fa fa-ban" />&nbsp;Remove Medication</a>
                                                </TooltipControl>

                                            </span>

                                        </template>


                                    </td>
                                </tr>
                                <tr class="border_top row_headers" v-if="!item.IsNew">
                                    <!--v-if="!item.IsUpdating">-->
                                    <!--<th></th>-->
                                    <th>Drug</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Quantity</th>
                                    <th>Notes</th>
                                    <th>Insulin</th>
                                    <th>EMAR</th>
                                    <th>CD</th>
                                    <th>BodyMap</th>
                                </tr>
                                <tr v-if="!item.IsNew">
                                    <td>
                                        <strong style="font-size:18px">{{item.drug.value.searchText}}</strong>
                                    </td>
                                    <td>{{FormatDate(item.startDate.value)}}</td>
                                    <td>{{FormatDate(item.endDate.value)}}</td>
                                    <td>{{item.quantity.value}} {{item.unitOfMeasure.value}}</td>
                                    <td>
                                        <!--<input class="form-control" type="text" v-model="item.notes.value" />-->
                                        {{item.notes.value}}
                                    </td>
                                    <td><span><i v-if="item.isInsulin.value" class="fa  fa-2x fa-check  text-success"></i></span></td>
                                    <td><span><i v-if="item.showInEMAR.value" class="fa fa-2x fa-check  text-success"></i></span></td>
                                    <td><span><i v-if="item.treatAsCD.value" class="fa  fa-2x fa-check  text-success"></i></span></td>
                                    <td><span><i v-if="item.useBodyMap.value" class="fa fa-2x fa-check  text-success"></i></span></td>
                                </tr>
                                <tr v-if="item.IsUpdating || item.IsNew">
                                    <td colspan="100">
                                        <DispensationItemBasicEditor :controller="item"></DispensationItemBasicEditor>
                                        <!--<span v-if="!item.IsNew">
                                            <button class="btn btn-sm btn-primary"
                                                    v-if="!item.HasDetailsChanged && !item.HasEndDateChanged "
                                                    @click="item.IsUpdating=false">
                                                &nbsp;&nbsp;&nbsp;&nbsp;Close&nbsp;&nbsp;&nbsp;&nbsp;
                                            </button>
                                            <button class="btn btn-sm btn-info" @click="item.ResetUpdates()">&nbsp;&nbsp;&nbsp;Reset&nbsp;&nbsp;&nbsp;</button>
                                        </span>-->
                                    </td>
                                </tr>

                                <tr class="border_top row_headers" v-if="!item.IsNew && !item.IsUpdating ">
                                     <th>Rounds</th>
                                    <th colspan="2">Dosage Pattern</th>
                                    <th colspan="2">Dosage Instruction</th>
                                    <th colspan="20"></th>
                                </tr>
                                <tr class="dosagerow" v-if="!item.IsNew && !item.IsUpdating ">
                                    <td colspan="1">
                                        <table class="roundTable" style="background:#eeeded!important">
                                            <thead>
                                                <tr>
                                                    <th><strong>Round</strong></th>
                                                    <th>Time</th>
                                                    <th>Quantity</th>
                                                </tr>
                                            </thead>
                                            <tbody style="font-size:13px">
                                                <tr v-for="round in NonZeroRounds(item.Original.medRounds)" class="border_top_thin">
                                                    <td>{{round.displayTextRound}}</td>
                                                    <td>
                                                        <span :style="{ 'background': HexColour(round.colourHex)}">
                                                            &nbsp;&nbsp;&nbsp;
                                                        </span>
                                                        &nbsp;
                                                        <span>
                                                            <strong>{{formatTime(round.roundTime)}}</strong>
                                                        </span>
                                                    </td>
                                                    <td style="text-align:center">{{round.dosage}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                    <td colspan="2">
                                        {{MapDaysOfDosage(item.Original.daysOfDosagePattern) }}
                                    </td>
                                    <td colspan="2">
                                        {{item.Original.dosageInstruction}}
                                    </td>
                                    <td colspan="20"></td>
                                </tr>
                                <tr v-if="item.IsUpdating || item.IsNew">
                                    <td colspan="100">
                                        <DispensationItemEditor :controller="item"></DispensationItemEditor>
                                        <!--<span v-if="!item.IsNew">
                                            <button class="btn btn-sm  btn-primary"
                                                    v-if="!item.HasChanged"
                                                    @click="item.IsUpdating=false">
                                                Close
                                            </button>
                                        </span>
                                        <span v-if="item.IsNew">
                                            <button class="btn btn-sm btn-warning" @click="controller.RemoveItem(item)">Cancel</button>
                                        </span>-->
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <tr>
                            <td colspan="100">
                                <br />
                                <button class="btn btn-info" @click="controller.CreateItem()"><i class="fa fa-plus"></i>&nbsp;Add Item</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!--</LoaderControl>-->
            <hr />

            <div class="form-group" v-bind:class="{ 'has-error' : controller.hasError,'has-warning' : controller.hasWarning ,'has-success' : controller.hasSuccess}">
                <!--<a class="btn btn-primary" :disabled="controller.hasError" @click.prevent.self="save()">Submit</a>-->
                <!--<WorkerButton :disabled="controller.hasError" :submit="controller.Save()" task="Med Profile Saved"></WorkerButton>-->
                <a href="#" class="btn btn-warning" @click.prevent.self="controller.Save()">Submit</a>
                <a href="#" class="btn btn-warning" @click.prevent.self="controller.Reset()">Reset</a>
                <span class="help-block">{{controller.message}}</span>
            </div>
            <div id="foo" v-if="controller.ChangeCount > 0">
                <div class="alert alert-dismissible alert-warning" style="margin:10px; opacity:0.6">
                    <!--<button type="button" class="close" data-dismiss="alert">&times;</button>-->
                    <strong>{{controller.ChangeCount}} Pending Changes. </strong><br /> Press submit to save.
                </div>

                <div class="alert alert-dismissible alert-danger" style="margin:10px; opacity:0.6" v-if="controller.hasError">
                    <!--<button type="button" class="close" data-dismiss="alert">&times;</button>-->
                    <strong>Clear all errors to save</strong><br />
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import { WardCycleDto, PatientOrderItemDto, DispensationItemDto, MedRoundDto } from './../../../dto/Dtos';
    import $ from 'jquery'
    import Formatter from "../../corecontrols/formatters/Formatter";
    import DrugSearchSelector from "../DrugSearchSelector/DrugSearchSelector.scp.html"
    import DrugStatusSelector from "./../drugStatusSelector/drugStatusSelector.scp.html";
    import DrugQuantityEditor from "./../drugQuantityEditor/drugQuantityEditor.scp.html";
    //import ServerErrorHandler from "./../servererrorhandler/servererrorhandler.scp.html";
    import Dal from './../../../scripts/dataaccess';
    import TooltipControl from './../../corecontrols/tooltipcontrol/tooltipcontrol.scp.html';
    import LoaderControl from './../../corecontrols/loaderControl/loaderControl.scp.html';
    import WorkerButton from './../../corecontrols/workerbutton/workerbutton.scp.html';
    import datepicker from "../../corecontrols/datepicker/datepicker.scp.html"
    import moment from 'moment'
    import TooltipControl from './../../corecontrols/tooltipcontrol/tooltipcontrol.scp.html';

    //import MedProfileEditor from './MedProfileEditor.scp.html'
    import DispensationItemEditor from './DispensationItemEditor.scp.html'
    import DispensationItemBasicEditor from './DispensationItemBasicEditor.scp.html'
    import { PatientMedProfile2Controller } from './PatientMedProfile2Controller';

    export default {
        props: ['patientid', 'startDate', 'endDate'],
        data: function () {
            return {
                patient: {},
                wards: [],
                patientWard: {},
                currentCycle: {},

                controlLoading: true,
                isLoading: true,
                cycleStartDate: undefined,
                cycleEndDate: undefined,
                currentCycleTitle: "",
                cycles: [],
                dispensationItems: [],

                currentDispensationItem: undefined,

                controller: {},
                today: new Date()
            }
        },
        mounted: function () {
            //console.log("Mounting Patient Med Profile 2 Control")

            this.controlLoading = true;
            var that = this;

            var dal = new Dal();
            dal.GetPatient(this.patientid).then(d => {
                that.patient = d;

                dal.GetWards(this.patient.carehomeId).then(wards => {
                    that.patientWard = wards.find(w => w.id == that.patient.wardId);
                }).then(() =>

                    dal.GetWardCycles(that.patient.wardId).then(cycles => {
                        var sortedCycles = cycles.sort((n1, n2) => {
                            if (n1.startDate > n2.startDate) return -1;
                            else if (n1.startDate < n2.startDate) return 1;
                            else return 0;
                        });

                        that.cycles = sortedCycles;

                        if (!that.cycleStartDate || !that.cycleEndDate) {
                            that.cycleStartDate = sortedCycles[1].startDate;
                            that.cycleEndDate = sortedCycles[1].endDate;
                            that.currentCycleTitle = "Current Cycle"
                            that.currentCycle = that.cycles.find(c => c.startDate == that.cycleStartDate);
                        }
                        this.controller = new PatientMedProfile2Controller();
                        this.controller.Initialize(this.currentCycle, this.patient, this.patientWard)
                        that.controlLoading = false;
                    })
                );
            })
        },
        methods: {
            HexColour: (argb) => Formatter.HexColour(argb),
            FormatDate: (dt) => Formatter.FormatDate(dt),
            formatTime: (t) => t,
            NonZeroRounds: (rounds) => {
                return rounds.filter(r => r.dosage && r.dosage.trim().length > 0).sort((a, b) => moment(a.roundTime, 'HH:mm').toDate().getTime() - moment(b.roundTime, 'HH:mm').toDate().getTime())
            },

            setCycle(cycle) {

                this.currentCycleTitle = this.cycles.indexOf(cycle) == 0 ? "Next Cycle" : this.cycles.indexOf(cycle) == 1 ? "Current Cycle" : " Cycle";
                console.log("setting cycle ", this.currentCycleTitle, cycle)

                this.cycleStartDate = cycle.startDate;
                this.cycleEndDate = cycle.endDate;
                this.currentCycle = cycle;
                //this.Load();
                this.controller.Initialize(this.currentCycle, this.patient, this.patientWard)

            },
            Load: () => {
                this.controller = new PatientMedProfile2Controller();
                //console.log("Loading ", this.currentCycle, this.patientWard, this.patient)
                this.controller.Initialize(this.currentCycle, this.patient, this.patientWard)
            },
            EditItem(item) {
                this.controller.DispensationItems.forEach(i => i.IsUpdating = false)
                item.IsUpdating = true;

                if (item.IsVirtual && !item.HasVirtualItemStarted) {
                    item.StartVirtualItem();
                }
            },
            MapDaysOfDosage(str) {
                if (str.trim().toLowerCase() == 'p') {
                    return 'PRN'
                }
                else if ( str.trim() == '1') {
                    return "Every Day"
                }
                else if ( str.trim() == '10') {
                    return "Every Second Day"
                }
                else if ( str.trim() == '100') {
                    return "Every Third Day"
                }
                else if(str.trim() == '1000') {
                    return "Every Fourth Day"
                }
                return "(Open to see dosage pattern)"
            },
    StopItem(item) {
        this.controller.DispensationItems.forEach(i => i.IsUpdating = false)
        //item.IsUpdating = true;
        item.StopActiveItem();
    },
    StartItem(item) {
        // A virtual item has been started
        item.StartVirtualItem();
        this.controller.DispensationItems.forEach(i => i.IsUpdating = false)
        //item.IsUpdating = true;
    },
    RemoveItem(item) {
        item.RemoveVirtualItem();
    },
    Reset() {
    },
    save() {

    }
        },
    components: {
        Formatter,
            LoaderControl,
            DrugStatusSelector,
            DrugQuantityEditor,
            DrugSearchSelector,
            TooltipControl,
            WorkerButton,
            //MedProfileEditor
            DispensationItemEditor,
            DispensationItemBasicEditor,
            datepicker
    }
    }
</script>


// WEBPACK FOOTER //
// PatientMedProfile2.scp.html?307d635c